<!--  -->
<template>
  <div class="workorer-container">
    <div id="carbonEmssionTrendByBuildChart" style="height: 100%; width: 100%"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      carbonEmssionTrendByBuildChart: null,
      carbonEmssionTrendByBuildChartOption: {},
      optionsDatas: [],
    };
  },

  components: {},

  // computed() {},

  mounted() {
    var self = this;

    self.carbonEmssionTrendByBuildChart = echarts.init(
      document.getElementById("carbonEmssionTrendByBuildChart")
    );
    self.queryData().then(() => {
      self.initTypeChartOption();
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.carbonByBuild).then((res) => {
          if (res.success) {
            res.returnObj.forEach((item) => {
              this.optionsDatas.push({
                value: item.carbonEmission ? item.carbonEmission.toFixed(2) : 0,
                name: item.buildName,
                label: {
                  normal: { show: true, position: "inner", formatter: "{d}%" },
                },
              });
            });
            console.log(res);
            resolve(res);
          }
        });
      });
    },
    initTypeChartOption() {
      let data = this.optionsDatas;
      this.carbonEmssionTrendByBuildChart = echarts.init(
        document.getElementById("carbonEmssionTrendByBuildChart")
      );

      //   let data = [
      //     {
      //       value: 25,
      //       name: "已处理",
      //       label: {
      //         normal: { show: true, position: "inner", formatter: "{d}%" },
      //       },
      //     },
      //     {
      //       name: "未处理",
      //       value: 87,
      //       label: {
      //         normal: { show: true, position: "inner", formatter: "{d}%" },
      //       },
      //     },
      //   ];
      this.carbonEmssionTrendByBuildChartOption = {
        // title: {
        //   text: "告警类型",
        //   top: "35%",
        //   left: "48%",
        //   textAlign: "center",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: "12px",
        //   },
        // },
        // graphic: [
        //   {
        //     //环形图中间添加文字
        //     type: "text", //通过不同top值可以设置上下显示
        //     left: "center", //
        //     top: "35%",
        //     style: {
        //       text: "105",
        //       textAlign: "center",
        //       fill: "#fff", //文字的颜色
        //       fontSize: 28,
        //       lineHeight: 16,
        //     },
        //   },
        //   {
        //     //环形图中间添加文字
        //     type: "text", //通过不同top值可以设置上下显示
        //     left: "center", //
        //     top: "47%",
        //     style: {
        //       text: "工单处理",
        //       textAlign: "center",
        //       fill: "#fff", //文字的颜色
        //       fontSize: 16,
        //       fontWeight: 400,
        //       lineHeight: 16,
        //     },
        //   },
        // ],

        tooltip: {
          // trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          //   orient: "vertical",
          orient: "'vertical'",
          right: "0",
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          itemWidth: 6,
          itemHeight: 6,
          itemGap: 5,
          // formatter: function (name) {
          //   // let data = option.series[0].data;
          //   let tarValue = 0;
          //   for (let i = 0; i < data.length; i++) {
          //     if (data[i].name === name) {
          //       tarValue = data[i].value;
          //     }
          //   }
          //   let arr = [name + " " + tarValue + "tCO2e"];
          //   return arr.join("\n");
          // },
          //   itemGap: 112,
          // selectedMode: false,
        },
        color: [
          "#6495ED",
          "#FF6969",
          "#9BD342",
          "#FFDA00",
          "#AB4CD3",
          "#FB4CD3",
          "#FF1493",
          "#00BFFF",
          "#2E8B57",
          "#D2691E"
        ],
        series: [
          {
            name: "处理",
            type: "pie",
            radius: ["40", "90%"],
            // radius: ["40%", "80%"],
            center: ["40%", "50%"],
            avoidLabelOverlap: false,

            // roseType: "radius",
            label: {
              show: false,
              position: "center",
            },
            itemStyle: {
              borderRadius: 10,
              //   borderColor: "rgba(100,103,120,.4)",
              // borderColor: "transparent",

              borderWidth: 10,
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.optionsDatas,
            roundCap: 2, //可选项为1和2，不填则采用原有拼接方式
          },
        ],
      };

      this.carbonEmssionTrendByBuildChart.setOption(
        this.carbonEmssionTrendByBuildChartOption
      );
    },
  },
};
</script>
<style lang='scss' scoped>
.workorer-container {
  height: 100%;
}
</style>